import { useState, useCallback } from "react";
import { EventsList } from "../components/EventsList"
import { Header } from "../components/Header"
import { Hero } from "../components/Hero";
import { AuthModal } from "../../auth/components/AuthModal";
import { useAuth } from "../../../contexts/AuthContext";
import { AuthGuard } from "../../auth/components/AuthGuard";
import redirectTo from "../../../utils/redirect";
import { Helmet } from 'react-helmet-async'

const LandingPage = () => {
    const { isLoading, error, isAuthenticated, isInitialized} = useAuth();
    const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

    const handleOpenAuthModal = useCallback(() => {
        setIsAuthModalOpen(true);
    }, []);

    const handleCloseAuthModal = useCallback(() => {
        setIsAuthModalOpen(false);
    }, []);

    return (
        <div>
            <Helmet>
                <title>Punta Tech Meetup | Eventos</title>
                <meta name="description" content="Descubrí charlas, experiencias y networking del Punta Tech Meetup." />
                <link rel="canonical" href="https://puntameetup.com/" />
                <meta property="og:title" content="Punta Tech Meetup | Eventos" />
                <meta property="og:description" content="Descubrí charlas, experiencias y networking del Punta Tech Meetup." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://puntameetup.com/" />
            </Helmet>
            <AuthGuard requireAuth={false} isLoading={isLoading} isAuthenticated={isAuthenticated} isInitialized={isInitialized}>
                <Header onSignInClick={handleOpenAuthModal} theme="dark" />
                <Hero />
                <EventsList />
                
                {/* Auth Modal */}
                
            </AuthGuard>
            <AuthModal 
                isOpen={isAuthModalOpen} 
                onClose={handleCloseAuthModal} 
                isLoading={isLoading} 
                onSuccess={() => {
                    redirectTo('/dashboard');
                }}
                error={error}
                />
        </div>

    );
}

LandingPage.displayName = 'LandingPage';

export default LandingPage;